<template>
  <div
    v-if="stepData"
    class="step"
  >
    <component
      :is="question.questionComponent"
      v-for="question in questions"
      :key="question.questionId || question.questionComponent"
      :product-name="productName"
      :step-id="stepId"
      :question-id="question.questionId"
      v-bind="question.params || {}"
      :form-observer="formObserver"
      :form-data="form"
      :step-data="stepData"
      :step-shared-data="stepSharedData"
      @toast="showToast($event)"
      @input="stepData = { ...stepData, ...$event }"
      @reset-observer="$emit('reset-observer')"
      @set-step-shared-data="setStepSharedData"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';

import {
  createAbtastyScript,
  removeAbtastyScript,
} from '@/helpers/common';

import { cloneDeep } from 'lodash';

export default {
  name: 'form-motorhome-step-1',
  props: {
    formObserver: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    stepId: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  inject: [
    'constants',
    'config',
  ],
  data () {
    return {
      stepData: null,
      stepSharedData: {},
    };
  },
  watch: {
    stepData: {
      handler (val) {
        this.$emit('step-data', val);
      },
      immediate: true,
    },
    'formObserver.valid': {
      immediate: true,
      handler (val) {
        if (val) this.$emit('valid');
      },
    },
  },
  created () {
    this.$emit('tracking', this.stepId);
    this.stepData = cloneDeep(this.form[this.stepId]);
    this.formObserver.reset();

    createAbtastyScript(this.config);
  },
  beforeDestroy () {
    removeAbtastyScript(this.config);
  },
  computed: {
    dashcamHelpText () {
      return !this.constants.PARTNERS.Apricot.includes(this.config.partner) && {
        value: 'Our insurance providers may give you a discount if you have a dashcam fitted.',
        priceSensitive: true,
      };
    },
  },
  methods: {
    ...mapActions(['showToast']),
    setStepSharedData ({ estimatedValue }) {
      // no need to prefill estimated value if there's no such field yet at all
      if (!Object.prototype.hasOwnProperty.call(this.stepData, 'vehicleValue')) return;
      this.stepSharedData = {
        ...this.stepSharedData,
        estimatedValue,
      };
    },
  },
};
</script>
